import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { api, notifyErr, fetchBlobUrl, fmtDateTime } from "@/lib/api";

const LABELS = { name: "Ragione sociale", legal_form: "Forma giuridica", vat: "P. IVA", tax_code: "Codice fiscale", address: "Indirizzo", street_number: "Civico",
  zip: "CAP", city: "Comune", province: "Provincia", country: "Nazione", pec: "PEC", sdi_code: "SDI", phone: "Telefono", admin_email: "Email amministrativa",
  legal_rep_first_name: "Nome amministratore", legal_rep_last_name: "Cognome amministratore", legal_rep_tax_code: "CF amministratore", legal_rep_role: "Qualifica" };
const DOCS = { visura: "Visura camerale", id_front: "Documento (fronte)", id_back: "Documento (retro)" };

export function ActivationDialog({ link, onClose, onDone }) {
  const nav = useNavigate();
  const req = link?.activation_request;
  const open = async (k) => { try { window.open(await fetchBlobUrl(`/platform/demo/links/${link.id}/activation-file/${k}`), "_blank"); } catch (e) { notifyErr(e); } };
  const create = async () => {
    try { const r = await api.post(`/platform/demo/links/${link.id}/create-company`); toast.success(r.data.message); onDone(); onClose(); nav(`/piattaforma/societa/${r.data.company_id}`); } catch (e) { notifyErr(e); }
  };
  return (
    <Dialog open={!!link} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto scroll-thin" data-testid="activation-dialog">
        <DialogHeader><DialogTitle>Richiesta di attivazione · {req?.data?.name}</DialogTitle></DialogHeader>
        {req && <div className="space-y-4">
          <div className="text-sm">Piano richiesto: <strong>{req.plan}</strong> · inviata il {fmtDateTime(req.submitted_at)} · da {link.email}</div>
          <div className="grid sm:grid-cols-2 gap-x-6 gap-y-2 text-sm" data-testid="activation-data">
            {Object.entries(LABELS).map(([k, l]) => <div key={k}><div className="text-xs text-zinc-500">{l}</div><div>{req.data[k] || "—"}</div></div>)}</div>
          <div className="flex flex-wrap gap-2">{Object.entries(DOCS).filter(([k]) => link.activation_files?.[k]).map(([k, l]) => (
            <Button key={k} size="sm" variant="outline" onClick={() => open(k)} data-testid={`activation-file-${k}`}>{l}</Button>))}</div>
        </div>}
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Chiudi</Button>
          {link?.activation_company_id ? <span className="text-sm text-emerald-300 self-center" data-testid="activation-company-created">Società già creata</span>
            : <Button className="btn-brand" onClick={create} data-testid="activation-create-company">Crea società da richiesta</Button>}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
